import React from 'react'
import Icon from '../../Shared/Components/Icon'
import { IconForOption } from '../utils'
import Alert from '../../Shared/Components/Alert'
import { AlertType } from '../../Shared/Components/Alert/Alert'
import InlineLink from '../../Shared/Components/Links/InlineLink'
import { LinkType } from '../../Shared/Components/Links/types'
import { useTranslation } from 'react-i18next'
import { GOOGLE_MAPS_DIRECTIONS_BASE_URL } from '../../Shared/Services/Axios/Api'
import { MapInfoWindowContentProps } from './types'
import Panel from '../../Shared/Components/Panel'
import './Scss/_map-info-window-content.scss'

const MapInfoWindowContent = (props: MapInfoWindowContentProps) => {
    const { t } = useTranslation()

    const services =
        (props.stationDetails && props.stationDetails.services) || []
    const servicesStringArray = services.map(service =>
        t(`recyclingStations.options.label.${service}`)
    )
    const servicesString = servicesStringArray && servicesStringArray.join(', ')

    const getDirectionsUrl = (address: string) => {
        const addressPart = encodeURIComponent(address).replace(/%20/g, '+')
        return `${GOOGLE_MAPS_DIRECTIONS_BASE_URL}${addressPart}`
    }

    const openingHours =
        (props.stationDetails && props.stationDetails.openingHours) || []

    return (
        <div className={"info-window"}>
        <div className='info-window__content'>
            <button className='info-window__close-button'
                id={`${props.idPrefix}pexmap-infowindow-close-btn`}
            />
            <div className='info-window__content-header'>
                <h2>{props.stationDetails?.title}</h2>
                <div className='info-window__header-bottom'>
                    <div className='info-window__opening-hours-container'>
                        <div className='info-window__icons'>
                            {services.map(service => (
                                <Icon
                                    key={`infowindow-icon-${service}`}
                                    size={28}
                                    iconName={IconForOption[service as keyof typeof IconForOption]}
                                />
                            ))}
                        </div>
                        <span className='info-window__opening-hours'>
                            {t('recyclingStations.openToday')}{' '}
                            {props.stationDetails?.openingHoursToday}
                        </span>
                    </div>
                    {props.stationDetails?.specialInfo && (
                        <Alert
                            type={AlertType.DANGER}
                            text={props.stationDetails.specialInfo}
                        />
                    )}
                </div>
            </div>

            <span className='info-window__section-label'>
                {t('recyclingStations.services')}
            </span>
            <span className='info-window__section-text'>
                {servicesString}
                {` `}
                <span
                    id={`${props.idPrefix}more-info-modal-link-container`}
                    className="more-info-modal-link-container"
                ></span>
            </span>

            <span className='info-window__section-label'>
                {t('recyclingStations.address')}
            </span>
            <span className='info-window__section-text'>
                {props.stationDetails?.address}
                {` `}
                <InlineLink
                    type={LinkType.Extern}
                    text={t('recyclingStations.directions')}
                    url={getDirectionsUrl(props.stationDetails?.address || '')}
                />
            </span>

            <span className='info-window__section-label'>
                {t('recyclingStations.openingHours')}
            </span>
            <span className='info-window__section-text'>
                {openingHours.map(item => (
                    <span className='info-window__section-text__opening-hour' key={item}>{item}</span>
                ))}
            </span>

            {props.stationDetails && props.stationDetails.url && (
                <div className='info-window__opening-hours-info'>
                    <Panel type="info" compact={true}>
                        <span>
                            {t('recyclingStations.exceptionalOpeningHours')}{' '}
                            <InlineLink
                                text={props.stationDetails.title || ''}
                                type={LinkType.Extern}
                                url={props.stationDetails.url || ''}
                            />
                        </span>
                    </Panel>
                </div>
            )}
        </div>
        </div>
    )
}

export default MapInfoWindowContent